// extracted by mini-css-extract-plugin
module.exports = {"phone":"767px","tablet":"992px","desktop":"1200px"};